// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BarLanding_button__1xUXX {\n  margin-left: 0px;\n}\n", "",{"version":3,"sources":["webpack://src/Navigation/Bar/BarLanding.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB","sourcesContent":[".button {\n  margin-left: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": "BarLanding_button__1xUXX"
};
export default ___CSS_LOADER_EXPORT___;
